import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBXfmXAjxsObHTM08uB8Aa4QsX-EoS_gwI",
  authDomain: "veagroup-firebase.firebaseapp.com",
  projectId: "veagroup-firebase",
  storageBucket: "veagroup-firebase.appspot.com",
  messagingSenderId: "1093625034624",
  appId: "1:1093625034624:web:7bb780d1b1cd6dace63365"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
